import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * 범용 페이지네이션 컴포넌트.
 * 어떤 목록 페이지에서든 재사용 가능합니다.
 */
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const cur = Number(currentPage ?? 1);
    const total = Number(totalPages ?? 1);

    if (total <= 1) return null;

    // 모바일에서 보여줄 페이지 범위 계산 (최대 5개)
    const getPageRange = () => {
        let start = Math.max(1, cur - 2);
        let end = Math.min(total, start + 4);

        if (end - start < 4) {
            start = Math.max(1, end - 4);
        }

        const range = [];
        for (let i = start; i <= end; i++) {
            range.push(i);
        }
        return range;
    };

    const pages = getPageRange();

    return (
        <div className="flex justify-center items-center gap-1 sm:gap-2 py-6">
            <button
                disabled={cur === 1}
                onClick={() => onPageChange(cur - 1)}
                className="p-1 sm:p-2 rounded-full hover:bg-gray-100 disabled:opacity-10 transition-all text-gray-400 hover:text-blue-600 outline-none"
            >
                <ChevronLeft size={20} />
            </button>

            <div className="flex gap-1 sm:gap-1.5 flex-none items-center">
                {pages.map(page => (
                    <button
                        key={page}
                        onClick={() => onPageChange(page)}
                        className={`w-[32px] h-[32px] min-w-[32px] min-h-[32px] sm:w-[36px] sm:h-[36px] sm:min-w-[36px] sm:min-h-[36px] rounded-full text-[12px] sm:text-sm font-black transition-all flex items-center justify-center outline-none flex-none aspect-square ${cur === page
                                ? 'bg-blue-600 text-white'
                                : 'text-gray-400 hover:bg-gray-50'
                            }`}
                    >
                        {page}
                    </button>
                ))}
            </div>

            <button
                disabled={cur === total}
                onClick={() => onPageChange(cur + 1)}
                className="p-1 sm:p-2 rounded-full hover:bg-gray-100 disabled:opacity-10 transition-all text-gray-400 hover:text-blue-600 outline-none"
            >
                <ChevronRight size={20} />
            </button>
        </div>
    );
};

export default Pagination;
